import styled from 'styled-components';

export const Wrapper = styled.div<{ isActive: boolean }>`
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border: 1px solid ${({ isActive }) => (isActive ? '#F78E1E' : '#D9D9D9')};
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease;
  background: #fff;

  &:hover {
    border-color: ${({ isActive }) => (isActive ? '#F78E1E' : '#D9D9D9')};
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;